// extracted by mini-css-extract-plugin
export default {"link":"RemoveUser_link__Doau3","breathing":"RemoveUser_breathing__c-XKP"};